import { render, staticRenderFns } from "./PlatformSpecification.vue?vue&type=template&id=6da3639b&scoped=true"
import script from "./PlatformSpecification.vue?vue&type=script&lang=js"
export * from "./PlatformSpecification.vue?vue&type=script&lang=js"
import style0 from "./PlatformSpecification.vue?vue&type=style&index=0&id=6da3639b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da3639b",
  null
  
)

export default component.exports